import { AsYouType, parsePhoneNumberFromString } from 'libphonenumber-js/min'

/**
 * Returns true if the value parses as a valid US phone number.
 * Used for SMS dialogs that only allow US destinations.
 */
export const isUsPhoneNumber = (value) => {
  if (!value || !String(value).trim()) return false
  try {
    const parsed = parsePhoneNumberFromString(String(value).trim(), 'US')
    return parsed != null && parsed.country === 'US'
  } catch {
    return false
  }
}

export const formatPhoneForDisplay = (value, defaultCountry = 'US') => {
  if (!value) return ''
  const raw = String(value).trim()
  if (!raw) return ''

  try {
    const parsed = parsePhoneNumberFromString(raw, defaultCountry)
    if (!parsed) return raw
    return parsed.formatNational()
  } catch {
    return raw
  }
}

export const sanitizePhoneInput = (value) => {
  if (!value) return ''
  const raw = String(value).trim()
  if (!raw) return ''

  if (raw.startsWith('+')) {
    return raw
  }

  return raw.replace(/[^\d]/g, '')
}

export const formatPhoneForInput = (value, defaultCountry = 'US') => {
  if (!value) return ''
  const raw = String(value).trim()
  if (!raw) return ''

  try {
    if (raw.startsWith('+')) {
      return new AsYouType().input(raw)
    }
    const digitsOnly = raw.replace(/[^\d]/g, '')
    return new AsYouType(defaultCountry).input(digitsOnly)
  } catch {
    return raw
  }
}

export const preparePhoneForSubmit = ({ value, showCountrySelector = false, dialCode = '+1' }) => {
  const sanitized = sanitizePhoneInput(value)
  if (!sanitized) return ''
  if (sanitized.startsWith('+')) return sanitized
  if (!showCountrySelector) return sanitized
  return `${dialCode}${sanitized}`
}

export const shouldShowCountryCodeSelector = (countryCode) => {
  return String(countryCode || '').toUpperCase() !== 'US'
}

